module.exports = __webpack_public_path__ + "static/media/nav-icon1.32152ae1.svg";